import ProductListSkeleton from "./product-list-skeleton";
import { Skeleton } from "@/components/ui/skeleton";

export default function ShopSkeleton() {
  return (
    <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Title Skeleton */}
      <Skeleton className="w-48 h-10 mx-auto mb-8" />

      {/* Search Bar Skeleton */}
      <div className="relative w-full max-w-xl mx-auto mb-12">
        <Skeleton className="w-full h-10 rounded-md" />
      </div>

      {/* Products Grid Skeleton */}
      <ProductListSkeleton 
        count={8} 
        className="grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-6 sm:gap-8 mb-12" 
      />

      {/* Pagination Skeleton */}
      <div className="flex flex-wrap justify-center items-center gap-2 mt-8">
        <Skeleton className="w-20 h-10 rounded-md" />
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="w-10 h-10 rounded-md" />
        ))}
        <Skeleton className="w-20 h-10 rounded-md" />
      </div>
    </div>
  );
}

